//Node Modules

//My Components
import { Sector } from "../home";
import { useRef } from "react";

//3rd Party Components

//State

//Config

//Helpers

//Other

const SectorDialog = ({ allSectorImg, sectorList }) => {
	//Hooks
	const dialogRef = useRef();

	return (
		<>
			<button type="button" className="jSelf-end" onClick={() => dialogRef.current.showModal()}>
				View By Sector
			</button>
			<dialog ref={dialogRef} className="sectorDialog">
				<div className="flex jContent-spaceBetween marginBottom-small">
					<h2>Projects by Sector</h2>
					<i className="bi bi-x" onClick={() => dialogRef.current.close()} />
				</div>
				<div className="grid-wrapper grid-columns-autoFill projectSector-wrapper">
					<Sector sectorTitle="All Sectors" slug={"all"} image={allSectorImg} />
					{sectorList.items.map((sector) => (
						<Sector key={sector.sys.id} sectorTitle={sector.name} slug={sector.slug} image={sector.image.url} />
					))}
				</div>
			</dialog>
		</>
	);
};

export default SectorDialog;
